import logger from "../../../../lib/logger";
import { mapPrice } from "./price";

const isValid = product => !!product.name || !!mapPrice(product.price);

export const filterInvalidProducts = (products = []) =>
  products.filter(product => {
    if (!isValid(product)) {
      logger.warn("Invalid product data from Search API", {
        ...product,
        type: "InvalidProduct"
      });

      return false;
    }

    return true;
  });
